import tenantRoutes from '@routes';

export const POST_LISTING_STEP_PARAM = 'step';

export const POST_LISTING_STEPS = {
  LICENSE_NUMBER: 'license-number',
  PERMIT_NUMBER: 'permit-number',
};

export const POST_LISTING_OPTION_KEYS = {
  SELL_RENT_LISTING: 'sell_rent_listing',
  REQUEST_AD_LICENSE: 'request_ad_license',
  DAILY_RENTAL: 'daily_rental',
};

export const getPostListingOptions = ({ t }) => {
  const postListingPath = tenantRoutes.app().post_listing.path;

  return [
    {
      key: POST_LISTING_OPTION_KEYS.SELL_RENT_LISTING,
      label: t('Sale/Rent Listing'),
      icon: 'PropertyIcon',
      path: `${postListingPath}?${POST_LISTING_STEP_PARAM}=${POST_LISTING_STEPS.LICENSE_NUMBER}`,
      analyticsName: 'sell_rent_listing',
      isNew: false,
    },
    {
      key: POST_LISTING_OPTION_KEYS.REQUEST_AD_LICENSE,
      label: t('Request Ad License'),
      icon: 'PostListingLicenseIcon',
      path: tenantRoutes.app().ad_license.path,
      analyticsName: 'request_ad_license',
      isNew: true,
    },
    {
      key: POST_LISTING_OPTION_KEYS.DAILY_RENTAL,
      label: t('Daily Rental Listing'),
      icon: 'RentalIcon',
      path: `${postListingPath}?${POST_LISTING_STEP_PARAM}=${POST_LISTING_STEPS.PERMIT_NUMBER}`,
      analyticsName: 'daily_rental_listing',
      isNew: false,
    },
  ];
};

export const getPostListingCardCopy = ({ t }) => ({
  [POST_LISTING_OPTION_KEYS.SELL_RENT_LISTING]: {
    description: t('Publish a property using a REGA Ad License.'),
    meta: t('REGA ad licence required'),
    action: t('Post Now'),
  },
  [POST_LISTING_OPTION_KEYS.REQUEST_AD_LICENSE]: {
    description: t('Generate a new REGA ad license for your property'),
    meta: t('Bayut gets your licence issued'),
    action: t('Create licence'),
  },
  [POST_LISTING_OPTION_KEYS.DAILY_RENTAL]: {
    description: t('Host guests at your place for short stays'),
    meta: t('MOT permit required'),
    action: t('Post Now'),
  },
});
